import { useEffect, useRef, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import eventsBgVideoMobile from '../../assets/events/events-bg-mobile.mp4';
import eventsBgImageMobile from '../../assets/events/events-bg-mobile.png';
import eventsBgVideoDesktop from '../../assets/events/events-bg.mp4';
import eventsBgImageDesktop from '../../assets/events/events-bg.png';

import styles from './AnimatedBackground.module.scss';

const AnimatedBackground = () => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const videoSrc = isMobile ? eventsBgVideoMobile : eventsBgVideoDesktop;
  const imageSrc = isMobile ? eventsBgImageMobile : eventsBgImageDesktop;

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    setIsVideoLoaded(false);
    video.load();

    const handleCanPlay = () => {
      setIsVideoLoaded(true);
      video.play().catch(() => {
        // Ignore autoplay errors
      });
    };

    video.addEventListener('canplay', handleCanPlay);

    return () => {
      video.removeEventListener('canplay', handleCanPlay);
    };
  }, [videoSrc]);

  return (
    <div className={styles.backgroundContainer}>
      <img
        src={imageSrc}
        alt=""
        className={twMerge(styles.backgroundImage, isVideoLoaded ? styles.hidden : '')}
        aria-hidden="true"
      />
      <video
        ref={videoRef}
        className={twMerge(styles.backgroundVideo, isVideoLoaded ? styles.visible : '')}
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
      </video>
    </div>
  );
};

export default AnimatedBackground;
